export const AW_COOKIE = {
  AUTH_TOKEN: 'X-Auth-Token',
  LOGIN_TOKEN: 'X-Login-Token',
  CURRENCY: 'X-Currency',
  REGION: 'X-Region',
  SESSION_ID: 'Session-ID',
  USER_ID: 'User-ID',
  LAST_USER_ID: 'Last-User-ID',
  SBK_REGION: 'X-Sportsbook-Region',
  X_ACCOUNT_SESSION: 'x-account-session',
};

export const SESSION_NAME = 'session-casino';

export const HEADERS = {
  CACHE_CONTROL: 'Cache-Control',
  X_PRODUCT_REGION: 'X-Product-Region',
};

export const FABRIC_HEADERS = {
  X_REGION_CODE: 'X-Region-Code',
  X_BRAND: 'X-Brand',
  X_AUTH: 'X-Auth-Token',
  X_LOGIN: 'X-Login-Token',
  X_DOMAIN: 'X-Base-Domain',
};

/** @deprecated Use {@link FABRIC_HEADERS} — kept for legacy imports. */
export const AGGREGATION_HEADERS = {
  X_REGION_CODE: FABRIC_HEADERS.X_REGION_CODE,
  X_BRAND: FABRIC_HEADERS.X_BRAND,
};

export const SESSION_COOKIE = {
  START_TIME: 'userSessionStartTime',
  STATE_TIME: 'currentStateTime',
};

export const GEOLOCATION_COOKIES = {
  IP_ADDRESS: 'geocomply_ip_address',
  XSELL_GEOLOCATION_TOKEN: 'XsellGeocomplyToken',
  XSELL_GEOLOCATION_TOKEN_UPDATED: 'XsellGeocomplyTokenUpdated',
  X_GEOLOCATION_TOKEN: 'X-Geocomply-Token',
};
